<template>
    <span>
        <b-button 
            class="ml-2"
            variant="primary"
            @click.stop="abrirModal()"
        >
            <span>
                Atualizar por movimento de compra
            </span>
        </b-button>
        <b-modal 
            v-model="mostrarModal" 
            @close="fecharModal()"
        >
            <div slot="modal-title">
                Busca de movimento
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12" md="12">
                    <b-form-group>
                        <label class="required" for="movimento">Id do movimento no RM</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                id="movimento"
                                placeholder="Digite o id do movimento"
                                v-model="movimentoId"
                                v-mask="['#########']"
                            ></b-form-input>
                            <b-form-invalid-feedback>
                                O id do movimento é obrigatório
                            </b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    class="mr-2"
                >
                    Cancelar
                </b-button>
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarObterMovimento()"
                >
                    Atualizar despesa
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        despesa: {
            type: Object,
            default: () => ({})
        },

        servicos: {
            type: Object
        }
    },
   
    data() {
        return {
            mostrarModal: false,
            movimentoId: null,
            erros: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            this.movimentoId = null
            this.erros = []
        },

        confirmarObterMovimento() {
            this.$swal({
                title: 'Despesa',
                html: `Confirma a atualização dessa despesa com o movimento de id <strong>${this.movimentoId}</strong>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.obterMovimento()
                }
            })
        },

        obterMovimento() {
            this.$store.dispatch('addRequest')
            let despesaDto = {
                idMov: this.movimentoId,
                despesaId: this.despesa.despesaId
            }
            this.servicos.atualizarDespesaCompra(despesaDto).then(response => {
                if (response) {
                    if (response.success && response.data) {
                        this.$toast.success(
                            'Despesa atualizada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterAtualizacao')
                        this.fecharModal()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },

    validations: {
        movimentoId: {
            required
        }
    },
}
</script>